import { LookupScreeningOutcomeType } from "@/api/dtos";
import { createContext } from "react";


interface IScreeningDialogContext {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    patientStudyNumber: string | null;
    setPatientStudyNumber: (patientStudyNumber: string | null) => void;
    screeningOutcome: LookupScreeningOutcomeType | null,
    setScreeningOutcome: (screeningOutcome: LookupScreeningOutcomeType | null) => void;
    institutionCode: string | null | undefined;
}




/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const ScreeningDialogContext = createContext<IScreeningDialogContext>({
    dialogOpen: false,
    setDialogOpen: (_open) => undefined,
    patientStudyNumber: null,
    setPatientStudyNumber: (_patientStudyNumber) => undefined,
    screeningOutcome: null,
    setScreeningOutcome: (_screeningOutcome) => undefined,
    institutionCode: null
});

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default ScreeningDialogContext;